import { render, staticRenderFns } from "./LoginIT.vue?vue&type=template&id=0af5aeb9&"
import script from "./LoginIT.vue?vue&type=script&lang=js&"
export * from "./LoginIT.vue?vue&type=script&lang=js&"
import style0 from "./LoginIT.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports